/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
//
/**/

  window.clickGiftnote = function(){
    const giftnoteButton = document.querySelector('.mini-cart-giftnote-button');
    if (giftnoteButton) {
      const originalButton = giftnoteButton.shadowRoot.querySelector('button[command="show-modal"]');
      if(originalButton){
        originalButton.click();
      }
    }
    console.log("click",giftnoteButton,originalButton)
  }
let cookiesyesTimes = 0;
if(window.innerWidth <= 440 && Cookies.get("cookieyes-consent") && Cookies.get("cookieyes-consent").indexOf("advertisement:no") != -1){
    let checkForCookiesyes = setInterval(() => {
        const tge = document.querySelector(".cky-consent-container .cky-notice")
        if (tge) {
            const customizebtn = document.querySelector('.cky-btn.cky-btn-customize');
            tge.insertBefore(customizebtn, tge.firstChild);
            clearInterval(checkForCookiesyes);
        }
        if( cookiesyesTimes >= 40){
            clearInterval(checkForCookiesyes);
            checkForCookiesyes = null;
        }
        cookiesyesTimes++;
    }, 500);
}
fetch("https://ipinfo.io/json", {"method":"GET"})
.then(function (response) { return response.json() })
.then(function(data){
    window.Shopify.countryCode = data.country;
    window.Shopify.countryName = data.region;
    
    if(!Cookies.get('direct')){
        Cookies.set('direct', 'false', { expires: 1 })
    }
    if(!Cookies.get('noRedirect')){
        Cookies.set('noRedirect', 'false', { expires: 1 })
    }
    checkAndShowPopup(data.country);
    showElement(data.country);
    if(data.country == "US"){
        showElementUS(data.country)
    }else if("AE,SA,QA".includes(data.country) && showElementSA){
        showElementSA(data.country)
        console.log("data.q",data.country)
    }

    if( reorderPaymentIcons){
        reorderPaymentIcons(data.country)
    }
})
//
// fetch('/cart.js')
// .then(response => response.json())
// .then(async cart => {
//     window.Shopify.cart = cart;
//     document.documentElement.dispatchEvent(
//         new CustomEvent("cart:refresh", {
//             bubbles: true,
//             detail: {
//                 cart: cart,
//             }
//         })
//     );  
// })
// .catch(error => console.error('Error fetching the cart:', error));
//
function onIntersectionShake1t(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-shake1t');
        observer.unobserve(entry.target);
      }
    });
}
const observer12 = new IntersectionObserver(onIntersectionShake1t, {
  root: null, // 
  rootMargin: '30px', // 
  threshold: 1 // 
});
const target12 = document.querySelector('.shake1t')
if(target12){
    observer12.observe(target12);
}
//
var cartType = location.pathname;
var inputCode = "";
var authorization_token = ""
fetch("/payments/config", { "method": "GET" })
    .then(function (response) { return response.json() })
    .then(function (data) {
        authorization_token = btoa(data.paymentInstruments.accessToken)
    })
async function discountInput(element,code) {
    let discountListString = '';
    let isDrawerFrame = true;
    if(document.querySelector('.custom__discount-list'))
    {
        discountListString = document.querySelector('.custom__discount-list').getAttribute('discount-code-list')
    }
    else{
        isDrawerFrame= false;
    }
    element.setAttribute("aria-busy", "true");
    if(code)
    {
        inputCode =code.replace(/\s*/g, "");
    }
    else{
        inputCode = $(".discount-code-input").val().replace(/\s*/g, "");
    }
    if (inputCode) {
        // let body = { "checkout": { "country": Shopify.country, "discount_code": inputCode, 'presentment_currency': Shopify.currency.active } }
        // await fetch('/wallets/checkouts/', {
        //     "headers": {
        //         "accept": "*/*", "cache-control": "no-cache",
        //         "authorization": "Basic " + authorization_token,
        //         "content-type": "application/json, text/javascript",
        //         "pragma": "no-cache", "sec-fetch-dest": "empty",
        //         "sec-fetch-mode": "cors", "sec-fetch-site": "same-origin"
        //     },
        //     "referrerPolicy": "strict-origin-when-cross-origin",
        //     "method": "POST", "mode": "cors", "credentials": "include",
        //     "body": JSON.stringify(body)
        // })
        // .then(function (response) {
        //     if ("200,201".indexOf(response.status) == -1) {
        //         errorInput();
        //         element.setAttribute("aria-busy", "false")
        //         throw false;
        //     } else {
        //         return response.json()
        //     }
        // })
        // .catch(function (error) {
        //     element.setAttribute("aria-busy", "false");
        //     throw false;
        // })
        let discountApplyUrl = "/checkout?discount=" + discountListString + inputCode;
        await fetch(discountApplyUrl, {}).then(
        function() {
            if(isDrawerFrame){
                fetchCartAndUpdateCart('apply');
            }
        }
        ).catch(function(error) {
            if(isDrawerFrame){
                fetchCartAndUpdateCart('apply');
            }
        })
    }
    else {
        if(isDrawerFrame){
            errorInput();
            element.setAttribute("aria-busy", "false");
        }
    }
}
async function fetchCartAndUpdateCart(type,rcart) {
    if(rcart)
    {
       await updateCartDisplay(rcart);
       if (type == 'apply') {
           checkoutDiscountUseSituation(rcart)
       }
       if (type == 'remove'){
           document.documentElement.dispatchEvent(
               new CustomEvent("cart:refresh", {
                   bubbles: true,
                   detail: {
                       cart: rcart,
                   }
               })
           );  
       }
    }else{
    fetch('/cart.js')
        .then(response => response.json())
        .then(async cart => {
            await updateCartDisplay(cart);
            if (type == 'apply') {
                checkoutDiscountUseSituation(cart)
            }
            if (type == 'remove'){
                document.documentElement.dispatchEvent(
                    new CustomEvent("cart:refresh", {
                        bubbles: true,
                        detail: {
                            cart: cart,
                        }
                    })
                );  
            }
            document.querySelector(".discount-code-submit").setAttribute("aria-busy", "false");
        })
        .catch(error => console.error('Error fetching the cart:', error));
    }
}
function getCurrency(currency) {
    return (0).toLocaleString(
        "en-us",
        {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            currencyDisplay: 'symbol'
        }
    ).replace(/\d/g, '').trim()
}
function checkoutDiscountUseSituation(cart) {
    let discountGroup = "";
    cart.items.forEach((item) => {
        if (item.discounts.length) {
            item.discounts.forEach((item)=>{
                discountGroup += item.title;
            })
        }
    });
    var reg = RegExp(inputCode.toLowerCase());
    if(discountGroup){
        if (!reg.test(discountGroup.toLowerCase())) {
            codeTipshow('tip');
        }else{
            document.documentElement.dispatchEvent(
                new CustomEvent("cart:refresh", {
                    bubbles: true,
                    detail: {
                        cart: cart,
                    }
                })
            );
        }
    }else{
        codeTipshow('warning');
    }
}
async function updateCartDisplay(cart) {
    let fetchCartSectionRespone = "";
    let cartContent = ""
    let CartSection = ''
    const countryCode = Shopify.locale+"-"+Shopify.country;
    const usFormatter = new Intl.NumberFormat(countryCode,{
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    if (cartType != "/cart") {
        fetchCartSectionRespone = await fetch('/cart/?section_id=mini-cart');
        cartContent = ".drawer__content"
    } else {
        fetchCartSectionRespone = await fetch('/cart/?section_id=main-cart');
        cartContent = ".container:has(.cart)"
    }
    let fetchCartSection = await fetchCartSectionRespone.text()
    let newdiv = document.createElement('div');
    newdiv.innerHTML = fetchCartSection;
    fetchCartSection = newdiv.querySelector(cartContent);

    let discountCodeList = [];
    let itemDiscountliElement = '';
    let currency = getCurrency(cart.currency);
    let levelDiscountCode = [];
    cart.cart_level_discount_applications.forEach((item) => {
        levelDiscountCode.push(item.title);
    })
    
    var additionalPDLength = 0;
    cart.items.forEach((item) => {
        if(item.properties['_adproduct id'])
        {
            return;
        }
        if (item.discounts.length) {
            item.discounts.forEach((discount) => {
                //记录所有应用discountcode
                if (!discountCodeList.includes(discount.title)) {
                    discountCodeList.push(discount.title)
                }
                //记录每一项discount
                if (!levelDiscountCode.includes(discount.title) && discount.amount != 0) {
                    itemDiscountliElement += `<li class="custom-item__discount-badge"><svg max-width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" aria-hidden="true" style="fill:none;stroke:rgba(0,0,0,0.56)" class=""><path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z"></path><circle cx="9.1" cy="4.9" r="0.7"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005z"></path></svg><span>${discount.title.toUpperCase()}</span><span>(-${currency + usFormatter.format(discount.amount / 100)})</span></li>`;
                }
            })
            //录入每一项line_item所用discount
            if(fetchCartSection.querySelectorAll(".line-item__info")[additionalPDLength]){
                fetchCartSection.querySelectorAll(".line-item__info")[additionalPDLength].querySelector('.custom-item__discount-list').innerHTML = itemDiscountliElement;
            }
            itemDiscountliElement = ''
        } else if(fetchCartSection.querySelectorAll(".line-item__info")[additionalPDLength]){
            fetchCartSection.querySelectorAll(".line-item__info")[additionalPDLength].querySelector('.custom-item__discount-list').innerHTML = ''
        }
        //录入每一项的价格和prepa
        if(fetchCartSection.querySelectorAll(".line-item__price-list-container .price-list")[additionalPDLength]){

            if (item.original_line_price != item.final_line_price ) {
                fetchCartSection.querySelectorAll(".line-item__price-list-container .price-list")[additionalPDLength].innerHTML = `<span class="price price--highlight"><span class="visually-hidden">Sale price</span><span class="notranslate ht-money">${currency + usFormatter.format(item.final_line_price / 100)}</span><!--Free!--></span><span class="price price--compare"><span class="visually-hidden">Regular price</span><span class="notranslate ht-money">${currency + usFormatter.format(item.original_line_price / 100)}</span></span></div>`
            }
            else {
                fetchCartSection.querySelectorAll(".line-item__price-list-container .price-list")[additionalPDLength].innerHTML = `<span class="price "><span class="visually-hidden">Sale price</span><span class="notranslate ht-money">${currency + usFormatter.format(item.final_line_price / 100)}</span></span>`
            }
        }
        additionalPDLength++;
    });
    //录入最后的总数
    const totalPrice = cart["items"].filter((item) => item["requires_shipping"]).reduce((sum, item) => sum + item["original_line_price"], 0);
    var fsb = fetchCartSection.querySelector("free-shipping-bar")
    
    fsb.style.setProperty("--progress", Math.min(totalPrice / fsb.threshold, 1));
    //录入全折扣
    let discountCodeListString =''
    if (discountCodeList.length != 0) {
        let discountliElement = ''
        discountCodeListString = discountCodeList.toString() + ","
        discountCodeList.forEach(item => {
            discountliElement += `<li class="custom__discount-badge"><div class="custom-discount-item"><svg max-width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" aria-hidden="true" style="fill:none;stroke:rgba(0,0,0,0.56)" class=""><path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z"></path><circle cx="9.1" cy="4.9" r="0.7"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005z"></path></svg><span class="discount-item-title">${item.toUpperCase()}</span><button onclick="removeDiscount(this)" type="button" name="discount" discount-code-id=${item} discount-code-list=${discountCodeListString}><svg focusable="false" width="14" height="14" class="icon icon--close " viewBox="0 0 14 14"><path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="1.3" fill="none"></path></svg></button></div></li>`
        });
        fetchCartSection.querySelector(".custom__discount-list").innerHTML = discountliElement
    } else { 
        fetchCartSection.querySelector(".custom__discount-list").innerHTML = ""
    }
    CartSection = document.querySelector(cartContent);
    fetchCartSection.querySelector('.custom__discount-list').setAttribute('discount-code-list',discountCodeListString)
    CartSection.innerHTML = fetchCartSection.innerHTML;
}
function removeDiscount(element) {
    document.querySelector(".discount-code-submit").setAttribute("aria-busy", "true");
    const removeCode = element.getAttribute("discount-code-id")
    const CodeList = element.getAttribute("discount-code-list")
    element.parentNode.parentNode.style = "display:none";
    const reg = new RegExp(`${removeCode},`, 'g')
    let endCode = CodeList.replace(reg, "")
    if (endCode) {
        let updateDiscountCodeUrl = "/checkout?discount=" + endCode;
        fetch(updateDiscountCodeUrl, {}).then(function () {
            fetchCartAndUpdateCart('remove');
        }).catch(function(){
            fetchCartAndUpdateCart('remove');
        })
    } else {
        // fetch("/discount", {}).then(function () {
        //     fetchCartAndUpdateCart('remove');
        // })
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: '' })
        }).then(response => response.json()).then(async cart =>{
            fetchCartAndUpdateCart('remove',cart);
        });
    }
}
function errorInput() {
    let inputElement = document.querySelector(".discount-code-input")
    inputElement.value = "";
    inputElement.setAttribute("aria-error", "true");
    document.querySelector(".discount-code-tip").setAttribute("hidden", "true")
    document.querySelector(".discount-code-error-tip span").innerHTML = inputCode.toUpperCase();
    function changefunction() {
        if (inputElement.value) {
            inputElement.setAttribute("aria-error", "false");
            inputElement.removeEventListener('input', changefunction)
        }
    }
    inputElement.addEventListener('input', changefunction)
}
function codeTipshow(type) {
    let tipTextContent = document.querySelector(".discount-code-tip .code-tip-textcontent")
    let tipContent =document.querySelector(".discount-code-tip")
    document.querySelector(".discount-code-tip .code-title").innerHTML = inputCode.toUpperCase();
    
    let shipCodeList = ['moonship','freeship','joei','moonkiefs']
    let is = shipCodeList.includes(inputCode.toLowerCase())
    if (is) {
        tipTextContent.innerHTML = "Shipping discount will apply at checkout based on your shipping address."
    }else if(type=='tip'){
        tipContent.setAttribute("type","tip")
        tipTextContent.innerHTML = "couldn't be used with your existing discounts. You've enjoyed the best discount which valid for the items in your cart now."
    }else if(type == 'warning'){
        tipContent.setAttribute("type","warning")
        tipTextContent.innerHTML="discount code isn't valid for the items in your cart"
    }
    document.querySelector(".discount-code-tip").removeAttribute("hidden")
}
function codeTipClose(element) {
    element.parentNode.setAttribute("hidden", "true");
}
/**/
// if (window.enableFlash) {
//   $(document).on("mrkVariant", function (event) {
//     if ($("#mrk-qty-selector").attr("url") != undefined) {
//       var url = $("#mrk-qty-selector").attr("url");
//       var mrkCollectionPage = true;
//     } else {
//       var url = location.pathname;
//       var mrkCollectionPage = false;
//     }
//     var id = $(event.detail.form).attr("id");
//     // $(`#${id}`).load(`${url} #${id}`);
//   });
// }

// if (window.enableFlash) {
//   $(function () {
//     if ($(".mrk-qty-container .quantity-selector__input").attr("min") == "0") {
//       $(".mrk-qty-container .quantity-selector__input").val(0);
//     }
//   });
// }
// gift event
$(document).on("cart:updated", function (event) {
    document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
          cart: event.detail.cart,
      }
        })
      );
})
$(document).on("cart:refresh", function (event) {
    var cart = event.detail.cart;
    if(cart.additem){
        if(window.Shopify.cart.items){
            window.Shopify.cart.items.push(cart.additem)
        }else{
            window.Shopify.cart.items = [];
        }
        window.Shopify.cart.total_price += cart.additem.final_price;
        cart = window.Shopify.cart
    }else{
        window.Shopify.cart = cart;
    }
  // Check if window.giftProductVariant.id exists in the cart items
//   console.log("cartrefresh",cart,window.giftProductVariant)
  if(!cart && !cart.items){
    return;
  }
  if(!window.giftProductVariant){
    return;
  }
  console.log("item",cart)
  var is_giftProductInCart = cart.items.some(function (item) {
        return item.product_id == window.giftProductVariant.product_id;
  });
  var gift_product_price_incart = 0;
  var gift_product_discountprice_incart = 0;
  // Find the gift product in the cart items and get its price
  var gift_product_incart = cart.items.find(function (item) {
        return item.product_id == window.giftProductVariant.product_id;
  });
  if (gift_product_incart) {
    gift_product_price_incart = gift_product_incart.final_line_price
    gift_product_discountprice_incart = gift_product_incart.total_discount
  }
  var line_items_final_price = 0;
  cart.items.forEach((item)=>{
    line_items_final_price += item.final_line_price;
  })
  var cartTotal = cart.total_price;
  if(is_giftProductInCart){
    var cartTotal = line_items_final_price - cart.total_discount + gift_product_discountprice_incart -  gift_product_price_incart;
  }
  var giftProductChangeNum = 0;
  if(cartTotal >= window.giftProductVariant.price) {
    giftProductChangeNum = 1;
  }
  if ((!is_giftProductInCart && giftProductChangeNum == 1) || (is_giftProductInCart && giftProductChangeNum == 0)){
    
    let updates = {};
    if(giftProductChangeNum == 1){
        updates = {
            [window.giftProductVariant.id]: giftProductChangeNum
          };
    }else{
        window.giftProductVariant.product.forEach((item,index)=>{
            updates[item.id] = 0;
        })
    }
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
            cart: data,
        }
          })
        );
      })
      .catch((error) => {
        console.error('Error:', error);
    });
  }
//   if (window.enableFlash) {
//     if ($("#mrk-qty-selector").attr("url") != undefined) {
//       var url = $("#mrk-qty-selector").attr("url");
//       var mrkCollectionPage = true;
//     } else {
//       var url = location.pathname;
//       var mrkCollectionPage = false;
//     }
//     if (url.includes("products")) {
//       $("#mrk-qty-selector").load(
//         `${url} #mrk-qty-selector`,
//         function (response, status, xhr) {
//           if (status == "error") {
//             console.log(
//               "Error loading the content: " + xhr.status + " " + xhr.statusText
//             );
//           } else {
//             var remValue = Number($("#mrk-qty-selector input").val());
//             if (remValue < 1) {
//               $(".product-form__buy-buttons").addClass("mrk-disabled");
//               $("#StickyAddToCart").addClass("mrk-disabled");
//               $("#AddToCart").prop("disabled", true);
//               $("#StickyAddToCart").prop("disabled", true);
//             } else {
//               $(".product-form__buy-buttons").removeClass("mrk-disabled");
//               $("#AddToCart").prop("disabled", false);
//               $("#StickyAddToCart").prop("disabled", false);
//               $("#StickyAddToCart").removeClass("mrk-disabled");
//             }
//           }
//         }
//       );
//     }
//   }
//换为
//   if (window.enableFlash) {
//     const qtyEl = document.getElementById('mrk-qty-selector');
  
//     if (!qtyEl) return;
  
//     let url = qtyEl.getAttribute('url') || location.pathname;
//     let mrkCollectionPage = qtyEl.hasAttribute('url');
  
//     if (url.includes('products')) {
//       fetch(url)
//         .then(res => res.text())
//         .then(html => {
//           // 将返回的 HTML 字符串解析为一个 DOM 文档
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(html, 'text/html');
  
//           const newQtyEl = doc.querySelector('#mrk-qty-selector');
//           const targetQtyEl = document.querySelector('#mrk-qty-selector');
  
//           if (newQtyEl && targetQtyEl) {
//             targetQtyEl.innerHTML = newQtyEl.innerHTML;
  
//             // 获取 input 中的值（库存数量）
//             const input = targetQtyEl.querySelector('input');
//             const remValue = input ? Number(input.value) : 0;
  
//             const addToCartBtn = document.getElementById('AddToCart');
//             const stickyAddToCartBtn = document.getElementById('StickyAddToCart');
//             const buyButtons = document.querySelector('.product-form__buy-buttons');
  
//             if (remValue < 1) {
//               buyButtons?.classList.add('mrk-disabled');
//               stickyAddToCartBtn?.classList.add('mrk-disabled');
//               addToCartBtn?.setAttribute('disabled', 'true');
//               stickyAddToCartBtn?.setAttribute('disabled', 'true');
//             } else {
//               buyButtons?.classList.remove('mrk-disabled');
//               stickyAddToCartBtn?.classList.remove('mrk-disabled');
//               addToCartBtn?.removeAttribute('disabled');
//               stickyAddToCartBtn?.removeAttribute('disabled');
//             }
//           } else {
//             console.warn('无法从远程文档中找到 #mrk-qty-selector');
//           }
//         })
//         .catch(err => {
//           console.error('加载内容出错：', err);
//         });
//     }
//   }
});

// 变体切换：silicone-toddler-cup-9-oz 的 71279473623293 变体隐藏加购按钮、显示 Coming Soon
document.addEventListener('variant:changed', function (event) {
  var variant = event.detail.variant;
  if (!variant) {
    return;
  }

  var productVariants = document.querySelector('product-variants');
  var handle = productVariants ? productVariants.getAttribute('handle') : '';
  var isTarget = handle === 'silicone-toddler-cup-9-oz' && String(variant.id) === '71279473623293';

  var addToCartBtn = document.getElementById('AddToCart');
  if (addToCartBtn) {
    if (isTarget) {
      addToCartBtn.style.setProperty('display', 'none', 'important');
    } else {
      addToCartBtn.style.removeProperty('display');
    }
  }

  var comingSoonLabel = document.querySelector('[data-coming-soon-label]');
  if (comingSoonLabel) {
    if (isTarget) {
      comingSoonLabel.style.removeProperty('display');
    } else {
      comingSoonLabel.style.setProperty('display', 'none', 'important');
    }
  }

  var labelList = document.querySelector('[data-product-label-list]');
  if (labelList) {
    if (isTarget) {
      labelList.style.setProperty('display', 'none', 'important');
    } else {
      labelList.style.removeProperty('display');
    }
  }

  var backInStockLabel = document.querySelector('[data-back-in-stock-label]');
  if (backInStockLabel) {
    if (isTarget) {
      backInStockLabel.style.removeProperty('display');
    } else {
      backInStockLabel.style.setProperty('display', 'none', 'important');
    }
  }

  var bundleProductContainer = document.querySelector('[data-bundle-product-container]');
  if (bundleProductContainer) {
    if (isTarget) {
      bundleProductContainer.style.setProperty('display', 'none', 'important');
    } else {
      bundleProductContainer.style.removeProperty('display');
    }
  }
});
